import fetchJson from './fetchJson';
import sd from 'fb-utils/serviceDiscovery';

export default function (subsystem, service, path, method, data, options) {
    return sd.instance().GetApi(subsystem, service).then(url => fetchJson(url + path, method, data, options));
}
